module.exports = __webpack_public_path__ + "img/73.a432de0f.png";